// src/components/pages/Portfolio.js
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../App.css";
import PortfolioHeader from "../PortfolioHeader";
import PortfolioFilters from "../PortfolioFilters";
import PortfolioGrid from "../PortfolioGrid";
import LightboxModal from "../LightboxModal";
import { PROJECTS } from "../../data/PortfolioData";
import Cta from "../Cta";
import Footer from "../Footer";

export default function Portfolio() {
  const location = useLocation();
  const navigate = useNavigate();

  const [filter, setFilter] = useState("All");
  const [modalProject, setModalProject] = useState(null);

  // Sync state from ?filter= query param
  useEffect(() => {
    const qs = new URLSearchParams(location.search);
    const raw = qs.get("filter") || "All";
    // normalize “360°” vs “360”
    const normalized = raw.replace("°", "");
    setFilter(raw === "All" ? "All" : normalized === "360" ? "360°" : raw);
  }, [location.search]);

  // Filter projects based on active filter
  const filtered = useMemo(() => {
    if (filter === "All") return PROJECTS;
    const key = filter.replace("°", "");
    return PROJECTS.filter((p) =>
      (p.tags || []).some((t) => t.replace("°", "") === key)
    );
  }, [filter]);

  return (
    <>
      <PortfolioHeader />

      {/* Filters (keeps URL in sync) */}
      <PortfolioFilters
        active={filter}
        onChange={(next) => {
          setFilter(next);
          const val = next.replace("°", "");
          navigate(val === "All" ? "/portfolio" : `/portfolio?filter=${val}`);
        }}
      />

      {/* Grid */}
      <PortfolioGrid
        items={filtered}
        onProjectClick={(p) => setModalProject(p)}
      />

      {/* Lightbox Quick View */}
      <LightboxModal
        show={!!modalProject}
        onHide={() => setModalProject(null)}
        title={modalProject?.title}
        media={modalProject?.media || []}
        startIndex={0}
        interval={6000}
      />

      {/* CTA + Footer */}
      <Cta
        headline="TRANSFORM YOUR PROPERTY'S APPEAL"
        subtext="and give potential buyers a reason to say yes faster."
        buttonLink="./contact"
        buttonText="Contact us"
      />
      <Footer />
    </>
  );
}
